import { Config, s3UploaderFolderName } from '@nw/shared/config';

export const getFileExtension = (fileName: string, fileType: string): string =>
  (fileName && fileName.slice(((fileName.lastIndexOf('.') - 1) >>> 0) + 2)) ||
  (fileType && fileType.slice(((fileType.lastIndexOf('/') - 1) >>> 0) + 2));

export const getFileNameFromS3Url = (s3Url: string): string => {
  const lastIndexOfSlash = s3Url.lastIndexOf('/');
  const nameOfTheFile = s3Url.substring(lastIndexOfSlash + 1, s3Url.length);
  return nameOfTheFile;
};

export const getS3FileUploaderUrl = (value: string) => {
  const { profilePic } = s3UploaderFolderName;
  const updatedUrl = value.replace(profilePic, `${Config.ENVIRONMENT}/media/`);

  return updatedUrl;
};
